<div id="classmentSinistreObject" class="w-100 d-inline-block"></div>